<template>
    <div id="container" class="container">
    	<myheader></myheader>
		<!-- <div class="mx1360">
			<div class="mbx">
				<div>您当前的位置：</div>
				<div><a href="/" class="cur curadm">首页</a> >> </div>
				<div v-if="lm"><a href="javascript:void(0)" class="cur curadm" @click="toback()">{{lm}}</a> >> </div>
				<div><span class="fc66">{{info.title}}</span></div>
			</div>
		</div> -->
		<div class="mx1360 docdetail">
			<div class="pd">
				
				<div class="doc-title">
					<div class="t">{{info.title}}</div>
					<!-- <div class="t2">{{info.subtitle}}</div> -->
				</div>
				<div class="source"><span>发布日期：{{info.create_time}}</span>
				<!-- <span>浏览次数：214</span> -->
				</div>
				<div class="doc-content text-justify">
						<!-- <div class="imgbox vcenter">
							<img src="http://www.29029.com/photos/202208/1_20220803141510232.jpg" class="p" />
						</div> -->
						<div class="text">
							<div v-html="info.content"></div>
					</div>
					
					<div class="doclist between">
						<ul>
							<!-- <li><a href="" class="cur curadm">【上一篇】：我国首座盐穴储气库完成扩能改造</a></li>
							<li><a href="" class="cur curadm">【下一篇】：“常泰”里的新“常态” 大桥带热两地周末消费</a></li> -->
						</ul>
						<div>
							<a class="cur curadm" @click="totop()">【返回顶部】</a>
						</div>
					</div>
					
				</div>
			</div>
		</div>
		<myfooter @getDetail="getDetail"></myfooter>
	</div>
</template>

<script>
import util from "@/common/util.js"
export default {
    data() {
        return {
            info:{},
			lm:""
        }
    },
    mounted() {
        
		this.id = util.getUrlParam("id")
		this.lm = util.getUrlParam("lm")
		this.getDetail()
    },
    methods: {
		getDetail(id){
			util.post("/web/web/detail",{
				id:id?id:this.id
			}).then((d)=>{
				this.info = d.data.data
				document.title=this.info.title
			})
		},
		totop(){
			window.scrollTo(0,0);
			// chrome 
			 document.body.scrollTop = 0 
			 // firefox
			 document.documentElement.scrollTop = 0 
		},
		toback(){
			util.toback()
		}
		
    }
}
</script>

<style lang="scss" scoped>
	@import '../style.scss'; //所有页面公用
    @import "./detail.scss";
</style>